import React, { useEffect } from "react";
import StatusBar from "../navbar/StatusBar";
import MenuOptionItem from "./MenuOptionItem";
import { useAppContext } from "../../context/appContext";
import LoadingSpinner from "../UI/LoadingSpinner";
import MenuItemContainer from "../menuItem/MenuItemContainer";

const MenuOptions = () => {
    const { displayItems, currentCategory, findItems, isLoading } = useAppContext();

    useEffect(() => {
        findItems(currentCategory);
    }, [currentCategory]);

    const items = [
        {
            name: "Starters",
        },
        {
            name: "Mains",
        },
        {
            name: "Desserts",
        },
        {
            name: "Soft Drinks",
        },
        {
            name: "Cocktails",
        },
        {
            name: "Wines",
        },
        {
            name: "Spirits",
        },
    ];

    return (
        <div>
            <StatusBar />
            <div className='m-2 flex flex-wrap gap-2'>
                {items.map((item, index) => {
                    let active = false;
                    if (currentCategory == item.name) {
                        active = true;
                    }
                    return <MenuOptionItem active={active} key={index} type={item.name} />;
                })}
            </div>
            {isLoading ? (
                <div className='flex h-full w-full items-center justify-center'>
                    <LoadingSpinner />
                </div>
            ) : (
                <MenuItemContainer displayItems={displayItems} />
            )}
        </div>
    );
};

export default MenuOptions;
